var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPillIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_18351_4777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.74086 6.74102L13.2587 13.2589M3.0164 10.4656L10.4654 3.01656C11.3297 2.15224 12.502 1.66666 13.7243 1.66666C14.9467 1.66666 16.119 2.15224 16.9833 3.01656C17.8476 3.88088 18.3332 5.05316 18.3332 6.2755C18.3332 7.49784 17.8476 8.67011 16.9833 9.53444L9.53428 16.9834C8.66995 17.8478 7.49768 18.3333 6.27534 18.3333C5.053 18.3333 3.88072 17.8478 3.0164 16.9834C2.15208 16.1191 1.6665 14.9468 1.6665 13.7245C1.6665 12.5022 2.15208 11.3299 3.0164 10.4656Z",
    stroke: "#181C32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18351_4777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillIcon);
export default __webpack_public_path__ + "static/media/pill-icon.408096dc757a6c8000c05b7f8edbf9e0.svg";
export { ForwardRef as ReactComponent };